export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAECAYAAAC+0w63AAAAFklEQVQYlWNUTV70n4EMwESOpoHRCADqOgIx8jNPUgAAAABJRU5ErkJggg=="